import { RelationModal } from "./types";

export const initialRelationModalState: RelationModal = {
  relationInfo: {
    referenceDatabaseId: null,
    referenceTableId: null,
    referenceViewId: null,
  },
  connectDataInfo: {
    recordId: null,
    headId: null,
    value: null,
    rowIndex: null,
    headKey: null,
    fieldDataType: null,
  },
  isShown: false,
};
